/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Wiki_Confirmdeleteentry2Inputs */



/**

* @param {_Wiki_Confirmdeleteentry2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _wiki_confirmdeleteentry2 = /** @type {((inputs?: _Wiki_Confirmdeleteentry2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Wiki_Confirmdeleteentry2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Wirklich löschen? Alle Entwürfe dieses Eintrages werden auch gelöscht.")
});
export { _wiki_confirmdeleteentry2 as "_wiki_confirmDeleteEntry" }